import { Injectable } from '@angular/core';
import { LocalDbService } from '../local-db-service';
import { Product } from '../../entities/product';

@Injectable({ providedIn: 'root' })
export class ProductRepository {
  private get table() {
    return this.db.productsTable;
  }

  constructor(private readonly db: LocalDbService) {}

  async getAll(): Promise<Product[]> {
    const rows = await this.table.toArray();
    return rows.map(row => new Product(row));
  }

  async getById(id: number): Promise<Product | undefined> {
    const row = await this.table.get(id);
    return row ? new Product(row) : undefined;
  }

  async searchByName(search: string): Promise<Product[]> {
    const normalizedSearch = search.trim().toLowerCase();

    if (!normalizedSearch) {
      return this.getAll();
    }

    const rows = await this.table
      .filter(row => row.name?.toLowerCase().includes(normalizedSearch))
      .toArray();

    return rows.map(row => new Product(row));
  }

  upsert(product: Product): Promise<number> {
    return this.table.put(product);
  }

  upsertBulk(products: Product[]): Promise<number> {
    return this.table.bulkPut(products);
  }

  delete(id: number): Promise<void> {
    return this.table.delete(id);
  }

  clear(): Promise<void> {
    return this.table.clear();
  }
}
